<template>
  <div class="message-input">
    <el-input
      ref="message-input"
      v-model="message"
      type="textarea"
      resize="none"
      :rows="1"
      :maxlength="250"
      :disabled="isDisabled"
      placeholder="Envoyer un message..."
      @keydown.enter.native.prevent="sendMessage" />

    <el-button
      type="text"
      :disabled="isDisabled"
      class="send-button"
      @click="sendMessage">
      <i class="el-icon-s-promotion" />
    </el-button>
  </div>
</template>

<script>
export default {
  name: "MessageInput",
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { message: "" }
  },
  watch: {
    isDisabled() {
      setTimeout(this.focus, 0)
    }
  },
  methods: {
    sendMessage() {
      this.focus()

      let value = this.message.replace(/(\r\n|\r|\n){2,}/g, "$1").trim()
      if (value.length) {
        this.$emit("send-message", value)
        this.message = ""
      }
    },
    focus() {
      this.$refs["message-input"].focus()
    }
  }
}
</script>

<style lang="scss">
.el-textarea textarea {
  border: none;
  font-size: 14px;
  color: color(plainBlack);
  padding: 18px 58px 18px 32px;
  background-color: transparent;
  transition: background-color 0.3s ease;

  &::placeholder {
    color: color(gray03);
  }
}
</style>

<style lang="scss" scoped>
.message-input {
  position: relative;
  border-top: 1px solid color(gray05);
  background-color: color(paperWhite);

  .send-button {
    position: absolute;
    right: 18px;
    top: 5px;

    i {
      font-size: 22px;
    }
  }
}
</style>